import React from 'react';
import { SectionHeading } from '../UI/Card';

const TABS = ['ALL', 'FLIGHT', 'HOTEL', 'BUS'];

const DealsTabs = ({ activeTab, onTabChange }) => {
  return (
    <SectionHeading
      eyebrow="Handpicked"
      title="Exclusive Deals"
      action={
        <div className="flex items-center gap-2 flex-wrap">
          {TABS.map((tab) => (
            <button
              key={tab}
              onClick={() => onTabChange(tab)}
              className={`px-4 py-2 text-sm font-semibold rounded-full border transition ${
                activeTab === tab
                  ? 'bg-brand-600 text-white border-brand-600'
                  : 'bg-white text-ink-600 border-ink-200 hover:border-brand-300 hover:text-brand-700'
              }`}
            >
              {tab === 'ALL' ? 'All' : tab.charAt(0) + tab.slice(1).toLowerCase()}
            </button>
          ))}
        </div>
      }
    />
  );
};

export default DealsTabs;
